import { TelegramBotUsername } from "../routes";

const COURSE_INTENT = "course";
const SEPARATOR = "__";

export function buildCourseStartParam(
  courseId: number,
  seasonId: number,
  episodeId: number,
  referralCode?: string,
): string {
  const values: Array<string | number> = [
    COURSE_INTENT,
    courseId,
    seasonId,
    episodeId,
  ];
  const code = referralCode?.trim();
  if (code) values.push(code);
  return values.join(SEPARATOR);
}

export function buildCourseEpisodeLink(
  courseId: number,
  seasonId: number,
  episodeId: number,
  referralCode?: string,
): string {
  const startParam = buildCourseStartParam(
    courseId,
    seasonId,
    episodeId,
    referralCode,
  );
  return `https://t.me/${TelegramBotUsername}/start?startapp=${encodeURIComponent(startParam)}`;
}
